/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Card, Button, CardBody, CardHeader, UncontrolledTooltip, ButtonGroup } from 'reactstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import SweetAlert from "react-bootstrap-sweetalert";

export default function MerchantDokumen(props) {
  const token = localStorage.token;
  const merchantPk = props.merchantPk;
  const merchantName = props.merchantName;
  const [merchantDocuments, setMerchantDocuments] = useState([]);
  const redirectPrefix = `/admin/customer/merchant/berkas-dokumen/${merchantPk}/edit/`;
  const [alert, setAlert] = React.useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [rowIndex, setRowIndex] = useState(0);
  const allowedRoles = ["ROLE_SUPERADMIN", "ROLE_OPERATOR_BUSDEV", "ROLE_BOD", "ROLE_OPERATOR_FINANCE", "ROLE_SUPERVISOR_FINANCE"]

  let paginationOption = {
    page: 1,
    alwaysShowAllBtns: true,
    override: true,
    showTotal: true,
    withFirstAndLast: false,
    onPageChange: (page) => {
      calculateRowIndex(page, currentPageSize);
    },
    sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          Show{" "}
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={(e) => {
                onSizePerPageChange(e.target.value);
                setCurrentPageSize(e.target.value);
                calculateRowIndex(currentPage, e.target.value);
              }}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          }{" "}
      entries.
    </label>
      </div>
    ),
  }

  const calculateRowIndex = (currentPage, currentPageSize) => {
    setRowIndex((currentPage - 1) * currentPageSize);
  }

  useEffect(() => {
    setMerchantDocuments([]);
    getMerchantAcquirer();
  }, [props.merchantPk]);

  const getMerchantAcquirer = () => {
    const data = { page: 1, per_page: 100, merchant_pk: merchantPk };
    fetch(`${process.env.REACT_APP_API_BASE_URL}/mcacquirers`, {
      method: 'POST', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setMerchantDocuments(data.response_data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const getMerchantDokumen = () => {
    const data = { page: 1, per_page: 100, merchant_pk: merchantPk };
    fetch(`${process.env.REACT_APP_API_BASE_URL}/mcacquirers`, {
      method: 'POST', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setMerchantDocuments(data.response_data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const delateMerchantAcquirer = (merchant_acquirer_id) => {
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/mcacquirer/delete/${merchant_acquirer_id}`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        setSuccessAlert();
        getMerchantDokumen();
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const setSuccessAlert = () => {
    setAlert(
      <SweetAlert
        success
        showConfirm
        confirmBtnText="Ok"
        title="Berkas deleted"
        onCancel={hideAlert}
        onConfirm={hideAlert}
      />
    )
  }

  const setQuestionAlert = (merchant_acquirer_id) => {
    setAlert(
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Yes"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => delateMerchantAcquirer(merchant_acquirer_id)}
        onCancel={hideAlert}
        focusCancelBtn
      />
    )
  }

  const hideAlert = () => {
    setAlert(null);
  }
  return (
    <>
      {alert}
      <Card>
        <CardHeader>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>List Berkas Dikirim ({merchantName})</h3>
            {
              allowedRoles.includes(localStorage.getItem("authority"))
                ?
                <div style={{ textAlign: "right" }}>
                  <Link className="btn btn-info" to={`/admin/customer/merchant/berkas-dokumen/${merchantPk}/create`}>
                    Add
              </Link>
                </div>
                :
                <div></div>
            }
          </div>
        </CardHeader>
        <CardBody>
          {
            allowedRoles.includes(localStorage.getItem("authority"))
              ?

              <ToolkitProvider
                rowNumber={rowIndex}
                data={merchantDocuments}
                keyField="merchant_acquirer_id"
                columns={[
                  {
                    dataField: "no",
                    text: "#",
                    sort: true,
                    page: 1,
                    formatter: (cell, row, index) => {
                      let currentRow = ++index;
                      return currentRow + rowIndex;
                    }
                  },
                  {
                    dataField: "acquirer_name",
                    text: "Acquirer Name",
                    sort: true,
                  },
                  {
                    dataField: "submitted",
                    text: "Berkas Dikirim",
                    sort: true,
                  },
                  {
                    dataField: "", text: "", formatter: (cell, row, index) => {
                      return (
                        <ButtonGroup>
                          <Button>
                            <Link
                              to={redirectPrefix + row.merchant_acquirer_id}
                              id={"tooltip_" + row.merchant_acquirer_id}
                            >
                              <i className="fas fa-user-edit" />
                            </Link>
                          </Button>
                          <UncontrolledTooltip delay={0} target={"tooltip_" + row.merchant_acquirer_id}>
                            Edit
                      </UncontrolledTooltip>
                          <Button
                            id="btn-acquirer"
                            onClick={() => setQuestionAlert(row.merchant_acquirer_id)}
                          >
                            <i className="fas fa-trash" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            placement="top"
                            target="btn-acquirer"
                          >
                            Delete Berkas
                      </UncontrolledTooltip>
                        </ButtonGroup>
                      )
                    }
                  },
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      pagination={paginationFactory({ ...paginationOption })}
                    />
                  </div>
                )}
              </ToolkitProvider>
              :
              <ToolkitProvider
                rowNumber={rowIndex}
                data={merchantDocuments}
                keyField="merchant_acquirer_id"
                columns={[
                  {
                    dataField: "no",
                    text: "#",
                    sort: true,
                    page: 1,
                    formatter: (cell, row, index) => {
                      let currentRow = ++index;
                      return currentRow + rowIndex;
                    }
                  },
                  {
                    dataField: "acquirer_name",
                    text: "Acquirer Name",
                    sort: true,
                  },
                  {
                    dataField: "submitted",
                    text: "Berkas Dikirim",
                    sort: true,
                  }
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      pagination={paginationFactory({ ...paginationOption })}
                    />
                  </div>
                )}
              </ToolkitProvider>
          }
        </CardBody>
      </Card>
    </>
  );
}
